export const parseList = (value: string | null): string[] =>
  value ? value.split(',').filter(Boolean) : [];
